import React from 'react'
import { T, cond } from 'ramda'
import Hero from '../../Article/List/Hero'
import Toast from '../../../legacy_components/Toastr/Toast'
import translations from '../translations'
import translate from '../../../utilities/translate'
import Divider from '../../../widgets/Layout/Divider'
import VerticalArticle from '../../Article/List/Vertical'
import VerticalMarketSpace from '../../MarketSpace/List/Vertical'
import PropTypes from 'prop-types'
import { getLocales, isHebrew } from '../../../utilities/locales'
import Banner from '../../../legacy_components/Homepage/Banner'
import BreakingNewsBanner from '../../../legacy_components/Homepage/BreakingNewsBanner'
import { HomepageAfterSectionMobileAdvert } from '../../Adverts/Taboola'
import { DESKTOP_VIEWPORT, MOBILE_VIEWPORT, MARKET_SPACE_TYPE } from '../../../utilities/constants'
import { ATFMobileDesktopAdvert, TopMobileAdvert } from '../../Adverts/Adnimation'
import styles from '../Headlines.module.css'

// trans :: String -> String -> String
const trans = translate(translations)

const Placeholder = ({ locale, viewport }) =>
  <div className={ styles.headlines }>
    <div className={ styles.hero }>
      <Hero.Placeholder />
      <Divider variant="hidden-web" />
      { viewport === MOBILE_VIEWPORT
        ? <>
          <TopMobileAdvert locale={ locale } />
          <Divider />
        </>
        : null
      }
    </div>
    <div className={ styles['side-items'] }>
      { Array.from({ length: 4 }).map((_, index) =>
        <div key={ `side-item-${index}` } className={ styles['side-item'] }>
          <VerticalArticle.Placeholder size='small' />
          <Divider variant="hidden-web" />
        </div>,
      ) }
    </div>
  </div>

const Items = ({ headlines, locale, viewport }) =>
  <div className={ styles.headlines }>
    <div className={ styles.hero }>
      <Hero article={ headlines[0].item } lazy={ false } />
      <Divider variant="hidden-web" />
      { viewport === MOBILE_VIEWPORT
        ? <>
          <BreakingNewsBanner />
          <Banner />
          <TopMobileAdvert locale={ locale } />
          <Divider />
        </>
        : null
      }
    </div>
    <div className={ styles['side-items'] }>
      { headlines.slice(1).map(headline => 
        <div className={ styles['side-item'] } key={ headline.item.id }>
          { headline.type === MARKET_SPACE_TYPE
            ? <VerticalMarketSpace
              marketSpace={ headline.item } 
              sponsoredTitle={ trans(locale)('sponsored') }
            />
            : <VerticalArticle size='small' article={ headline.item } lazy={ false } />
          }
          <Divider variant="hidden-web" />
        </div>,
      ) }
    </div>
  </div>

const Headlines = ({
  isFetching,
  headlines,
  locale,
  error,
  viewport,
}) =>
  <div id="homepage-headlines">
    { error ? <Toast message={ trans(locale)('error') } level="error" /> : null }

    { viewport !== MOBILE_VIEWPORT ? <BreakingNewsBanner /> : null }

    { cond([
      [() => isFetching, () => <Placeholder viewport={ viewport } />],
      [() => headlines.length === 0, () => null],
      [T, () => <Items headlines={ headlines } locale={ locale } viewport={ viewport } />],
    ])(headlines) }

    { viewport === MOBILE_VIEWPORT
      ? <>
        <HomepageAfterSectionMobileAdvert index={ 0 } />
        <Divider />
      </>
      : <>
        <ATFMobileDesktopAdvert locale={ locale } viewport={ DESKTOP_VIEWPORT } />
        <Divider />
        <Banner />
      </>
    }
  </div>

Headlines.propTypes = {
  headlines: PropTypes.arrayOf(PropTypes.object).isRequired,
  locale: PropTypes.oneOf(getLocales()).isRequired,
  isFetching: PropTypes.bool.isRequired,
  error: PropTypes.object,
  viewport: PropTypes.string.isRequired,
}

export default Headlines
